<template>
  <div class="cf-flex cf-flex--column cf-flex--gap-6">
    <h4 class="cf-title cf-title--4">
      {{ store.description }}
    </h4>

    <cf-store-directions
      :address="store.address"
      :element-type="'link'"
    />

    <cf-store-phone-number
      v-if="store.phoneNumber"
      :phone-number="store.phoneNumber"
      :element-type="'link'"
    />
  </div>
</template>


<script>
  import CfStorePhoneNumber from '@/view/components/shared/cf-store-phone-number/index.vue';
  import CfStoreDirections from '@/view/components/shared/cf-store-directions/index.vue';

  export default {
    name: 'CfReceiptFromLocationDetails',

    components: {
      CfStorePhoneNumber,
      CfStoreDirections
    },

    props: {
      store: {
        type: Object,
        required: true
      }
    }
  };
</script>
